module.exports = __webpack_public_path__ + "static/media/datacentre.c1b4cdbd.png";